import Link from 'next/link';

import { MainButton } from '../../atomic-atoms';
import { BrandLandingShell } from '../../shells';

import styles from './NotFound.module.scss';

export function NotFound({ linkTo }: { linkTo: string }) {
  return (
    <BrandLandingShell>
      <div className={styles.cta}>
        <h1>Looks like you are Lost...</h1>

        <Link href={linkTo}>
          <MainButton ariaLabel="Take me where I belong">
            Take me where I belong
          </MainButton>
        </Link>
      </div>
    </BrandLandingShell>
  );
}
